import React, { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Fuzou from "./components/knowledges/fuzou";
import Navbar from "./components/Navbar";
import SiteFooter from "./components/SiteFooter";

function App_zhishiku() {
  const [currentView, setCurrentView] = useState("zhishiku");
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  React.useEffect(() => {
    const token = localStorage.getItem("access_token");
    setIsLoggedIn(!!token);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    setIsLoggedIn(false);
  };

  return (
    <div className="flex flex-col  bg-gray-50">
        <Navbar
        currentView={currentView}
        setCurrentView={setCurrentView}
       
      />
      <main className="w-full">
        <Routes>
          <Route path="/zhouyu" element={<Fuzou />} /> 
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
   
    </div>
  );
}

export default App_zhishiku;